"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var Table_1 = __importDefault(require("@material-ui/core/Table"));
var TableBody_1 = __importDefault(require("@material-ui/core/TableBody"));
var TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
var TableContainer_1 = __importDefault(require("@material-ui/core/TableContainer"));
var TableHead_1 = __importDefault(require("@material-ui/core/TableHead"));
var TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));
var Paper_1 = __importDefault(require("@material-ui/core/Paper"));
var useQuery_1 = require("@control4/react-sdk/build/lib/connect-query/useQuery");
var useStyles = styles_1.makeStyles({
    table: {
        minWidth: 650,
    },
});
var NoDataFound = function () { return react_1.default.createElement("h1", null, "No Records Found"); };
var TableQuery = function (_a) {
    var columns = _a.columns, children = _a.children, config = __rest(_a, ["columns", "children"]);
    var classes = useStyles();
    var _b = useQuery_1.useQuery(config), requestStatus = _b.requestStatus, data = _b.data;
    return (react_1.default.createElement(TableContainer_1.default, { component: Paper_1.default },
        react_1.default.createElement(Table_1.default, { className: classes.table, "aria-label": "simple table" },
            react_1.default.createElement(TableHead_1.default, null,
                react_1.default.createElement(TableRow_1.default, null, columns &&
                    columns.map(function (col, index) { return (react_1.default.createElement(TableCell_1.default, __assign({ key: col.title || index }, col),
                        col.component && col.component,
                        col.title && col.title)); }))),
            react_1.default.createElement(TableBody_1.default, null,
                requestStatus &&
                    requestStatus.isFinished &&
                    data &&
                    (data === null || data === void 0 ? void 0 : data.length) > 0 &&
                    (columns
                        ? data.map(function (value, index) { return (react_1.default.createElement(TableRow_1.default, { key: index }, columns.map(function (col, index) {
                            var _a, _b;
                            return (react_1.default.createElement(TableCell_1.default, __assign({}, col, { key: index }), col.render ? col.render(value[(_a = col === null || col === void 0 ? void 0 : col.dataIndex) !== null && _a !== void 0 ? _a : ''], value) : value[(_b = col === null || col === void 0 ? void 0 : col.dataIndex) !== null && _b !== void 0 ? _b : '']));
                        }))); })
                        : children instanceof Function
                            ? children(data, requestStatus)
                            : children),
                (requestStatus === null || requestStatus === void 0 ? void 0 : requestStatus.isFinished) && (data === null || data === void 0 ? void 0 : data.lenght) === 0 && (react_1.default.createElement(TableRow_1.default, null,
                    react_1.default.createElement(TableCell_1.default, null,
                        react_1.default.createElement(NoDataFound, null)))),
                (requestStatus === null || requestStatus === void 0 ? void 0 : requestStatus.isPending) && (react_1.default.createElement(TableRow_1.default, null,
                    react_1.default.createElement(TableCell_1.default, null,
                        react_1.default.createElement("h1", null, "Loading..."))))))));
};
TableQuery.defaultProps = {
    loadData: true,
};
exports.default = TableQuery;
//# sourceMappingURL=TableQuery.js.map